import * as React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";

// These props are provided by the router
interface PathProps {
  history: any;
  location: any;
  match: any;
}
interface State {
  redirect: boolean;
}

class Afspraak extends React.Component<RouteComponentProps<PathProps>, State> {
  public state: State;

  constructor(props: any) {
    super(props);
    this.state = { redirect: true };
  }

  redirect = () => {
    let path = `https://start.james-software.nl/WebApp/RUFBQUFDWDY3TUkvUHkrSU1xZ2d2WmZqUk16ZEhiWUE4Tm1nT2xaZmx6K29FQ1pk0`;
    window.location.replace(path);
  };

  public render() {
    return (
      <div style={{ background: "white" }}>
        <Helmet>
          <meta charSet="utf-8" />
          <title>BOOST Fysiotherapie Afspraak Maken</title>
          <meta
            name="description"
            content="Hier kunt u snel en eenvoudig een afspraak maken."
          />
          <meta
            property="og:title"
            content="BOOST Fysiotherapie Afspraak Maken"
          />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href="/afspraak" />
        </Helmet>
        {this.redirect()}
      </div>
    );
  }
}

export default withRouter(Afspraak);
